import { useStorage } from '@vueuse/core'
import { defineStore } from 'pinia'
import { logger } from '../utility/logger'

interface FormData {
  [key: string]:
    | string
    | number
    | boolean
    | string[]
    | number[]
    | null
    | undefined
    | Record<string, unknown>
}

export const useFormStore = defineStore('form', () => {
  const formData = useStorage<FormData>('form-data', {})
  const authStore = useAuthStore(usePinia())

  if (process.client) {
    watch(
      () => authStore.isLoggedIn,
      (value, oldValue) => {
        if (!value && value !== oldValue) {
          clearFormData()
        }
      },
    )
  }

  function updateField(fieldName: string, value: any) {
    logger('updateField', fieldName, value, formData)
    formData.value[fieldName] = value
  }

  function updateTransientField(fieldName: string, value: any) {
    logger('updateTransientField', fieldName, value, '(not persisted)')
    // This function intentionally does not persist to localStorage
    // Used for fields that should not be remembered across sessions
  }

  function clearField(fieldName: string) {
    delete formData.value[fieldName]
  }

  function clearTransientFields() {
    // Clear fields that should not persist across booking sessions
    clearField('selectedExtras')
  }

  function clearFormData() {
    formData.value = {}
  }

  return {
    formData,
    updateField,
    updateTransientField,
    clearField,
    clearTransientFields,
    clearFormData,
  }
})
